// extracted by mini-css-extract-plugin
export default {"container":"AO-z","modal":"BO-z","dimensions":"CO-z","brandName":"DO-z","productName":"EO-z","labelValue":"FO-z","recipientEmail":"GO-z","recommendedFit":"HO-z","hiddenField":"IO-z"};